<section class="header-content">
  <app-page-title [type]="type"></app-page-title>

  @if (editMode()) {
    <div class="btn-edit">
      <button class="button" (click)="onAddAdvert()">Add Advert</button>
    </div>
  }
</section>
@for (article of articles; track article.id) {
  <app-gallery-article [article]="article" (deleted)="onDeleted($event)"></app-gallery-article>
}
